var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventorySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5781 16V6.5C19.5781 5.4 18.6781 4.5 17.5781 4.5H13.0781",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5781 2L12.5781 4.5L15.5781 7",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57812 9V16",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82812 8.5C7.62305 8.5 9.07812 7.04493 9.07812 5.25C9.07812 3.45507 7.62305 2 5.82812 2C4.0332 2 2.57812 3.45507 2.57812 5.25C2.57812 7.04493 4.0332 8.5 5.82812 8.5Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57812 22C7.23498 22 8.57812 20.6569 8.57812 19C8.57812 17.3431 7.23498 16 5.57812 16C3.92127 16 2.57812 17.3431 2.57812 19C2.57812 20.6569 3.92127 22 5.57812 22Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5781 22C21.235 22 22.5781 20.6569 22.5781 19C22.5781 17.3431 21.235 16 19.5781 16C17.9213 16 16.5781 17.3431 16.5781 19C16.5781 20.6569 17.9213 22 19.5781 22Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventorySvg);
export default __webpack_public_path__ + "static/media/inventory_svg.29584f8f486045efc31f921bbfd958ea.svg";
export { ForwardRef as ReactComponent };